/* eslint-disable import/no-named-default */
// import { scopeIds, scopeTypes, functionTypes, permissionConfigs } from './sdgrouphub/template/permission'

// export const customPermission = {
//     scopeIds,
//     scopeTypes,
//     functionTypes,
//     permissionConfigs
// }

export const customPermission = {}